<template>
    <div class="counter-divs cf">
        <div class="counter">
            <div>
                <p>
                    Vrijeme za  <br>predaju: <br>
                    <span class="af">{{ values.leftValue }}</span> <span>{{ values.rightValue }}</span><br>
                    <small>{{ values.leftDesc }}</small> <small>{{ values.rightDesc }}</small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { TimeUtils, DDHHMMSSCounterValues } from '../utils/timeUtils'
import { GlobalEvents } from '../event-bus'
export default {
    name: 'turn-in-counter',
    data: function () {
        return {
            turnInTimerRunOut: false
        }
    },
    computed: {
        seconds () {
            return this.$store.state.counters.seconds
        },
        values () {
            if (this.seconds > 0) {
                let timeObject = TimeUtils.secondsToTimeObject(this.seconds)
                return DDHHMMSSCounterValues(timeObject)
            } else {
                return DDHHMMSSCounterValues(TimeUtils.secondsToTimeObject(0))
            }
        }
    },
    watch: {
        seconds (after, before) {
            if (after <= 0) {
                if (!this.turnInTimerRunOut) {
                    this.$emit(GlobalEvents.TURN_IN_FINISHED)
                    this.turnInTimerRunOut = true
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.counter-divs {
    font-family: "mPlus";
    text-align: left;
    margin-left: -24px;
    font-size: 14px;
    letter-spacing: -.2px;
    display: block;

    > div {
        padding-left: 24px;
    }
    .counter {
        div {
            box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
            padding: 16px 14px 14px;
            background-color: #001840;
            color: #fff;
            border-radius: 10px;
            height: 100%;
        }
        p {
            margin: 0;
            white-space: nowrap;

            span {
                font-size: 25px;
                display: inline-block;
                margin: 5px 0 2px;
                min-width: 46px;
            }
            span.af:after {
                content: ':';
            }
            small {
                font-family: "axiforma";
                display: inline-block;
                text-transform: uppercase;
                font-size: 10px;
                letter-spacing: 1px;
                color: #85c0f8;
                min-width: 46px;
            }
        }
    }
}
</style>
